import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { listModuleLenses } from 'root/src/client/logic/list/lenses'

const { viewListType } = listModuleLenses

export default (state, { moduleId }) => viewListType(moduleId, moduleDescriptions)
